const SESSION_PREFIX = 'wrg.walletBal.v1.';

const memory = new Map();

function walletKey(addr) {
  return String(addr || '').toLowerCase();
}

export function peekWalletBalances(walletAddress) {
  const key = walletKey(walletAddress);
  if (!key) return null;
  const mem = memory.get(key);
  if (mem?.eth != null || mem?.usdc != null) return mem;
  try {
    const raw = sessionStorage.getItem(`${SESSION_PREFIX}${key}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && (parsed.eth != null || parsed.usdc != null)) {
      memory.set(key, parsed);
      return parsed;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function putWalletBalances(walletAddress, { eth, usdc }) {
  const key = walletKey(walletAddress);
  if (!key) return;
  const prev = peekWalletBalances(key) || {};
  const rec = {
    at: Date.now(),
    eth: eth != null ? String(eth) : prev.eth,
    usdc: usdc != null ? String(usdc) : prev.usdc,
  };
  memory.set(key, rec);
  try {
    sessionStorage.setItem(`${SESSION_PREFIX}${key}`, JSON.stringify(rec));
  } catch {
    /* ignore quota */
  }
}

export function invalidateWalletBalances(walletAddress) {
  const key = walletKey(walletAddress);
  if (!key) {
    memory.clear();
    return;
  }
  memory.delete(key);
  try {
    sessionStorage.removeItem(`${SESSION_PREFIX}${key}`);
  } catch {
    /* ignore */
  }
}
